import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core';
import { ReactChild } from './ContributionMappingColumn';

interface ContributionMappingRowProps {
  columnOne: ReactChild;
  columnTwo?: IconDefinition | IconProp;
  columnThree: ReactChild;
  className?: string;
}

const StyledDiv = styled.div`
  display: flex;
  margin-bottom: ${SPACERS.medium};
  .mapping-table-column-1 {
    flex: 1;
  }
  .mapping-table-column-2 {
    width: 62px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .mapping-table-column-3 {
    flex: 1;
  }
`;

const ContributionMappingRow: React.FC<ContributionMappingRowProps> = ({
  columnOne,
  columnTwo,
  columnThree,
  className,
}) => {
  return (
    <StyledDiv className={className}>
      <div className="mapping-table-column-1">{columnOne}</div>
      <div className="mapping-arrow-icon mapping-table-column-2">
        {columnTwo && <FontAwesomeIcon icon={columnTwo} />}
      </div>
      <div className="mapping-table-column-3">{columnThree}</div>
    </StyledDiv>
  );
};

export default ContributionMappingRow;
